export default [
    {
        name: "accueil",
        path: "/accueil"
    },
    {
        name: "Services",
        childrens: [
            {
                name: "fonctionnalités",
                path: "/fonctionnalites"
            },
            {
                name: "Pharmacies",
                path: "/pharmacies"
            },
            /*{
                name: "médicaments",
                path: "/medicaments"
            },
            {
                name: "API",
                path: "/api"
            },*/
        ]
    },
    {
        name: "gardePharma",
        childrens: [
            {
                name: "à propos",
                path: "/a-propos",
            },
            {
                name: "trouver médecin",
                path: "#",
            },
        ]
    },
    {
        name: "Blog",
        childrens: [
            {
                name: "tous",
                path: "/news",
            },
            {
                name: "maladie",
                path: "/news?=maladie",
            },
            {
                name: "nutrition",
                path: "/news?=nutrition",
            },
        ],
    },
    {
        name: "contact",
        path: "/contact",
    }
];
